import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {formatCurrency, getCurrencySymbol, getLocaleCurrencyCode, getNumberOfCurrencyDigits} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(@Inject(LOCALE_ID) private locale: string) { }

  formatCurrency(amount: number): string {
    const currencyCode = getLocaleCurrencyCode(this.locale) || "en";
    const currencySymbol = getCurrencySymbol(currencyCode, "narrow", this.locale);
    const decimals = amount.toString().split(".")[1]
    if(decimals && decimals.length) {
      const maxDecimal = decimals.length > 2 ? decimals.length : getNumberOfCurrencyDigits(this.locale);
      return formatCurrency(amount, this.locale,  currencySymbol, currencyCode, `1.2-${maxDecimal}`);
    }
    return formatCurrency(amount, this.locale, currencySymbol, currencyCode, '1.2-2');
  }
}
